import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Space, Modal, Divider } from 'antd';

const { confirm } = Modal;
const DANGER_COLOR = '#ff4d4f';

const ActionsMenu = ({ title = 'Actions', configs = [] , actionRecord }) => {
  // Central handler for clicks
  const handleMenuClick = ({ key, domEvent }) => {
    domEvent?.stopPropagation();
    const cfg = configs[key];
    if (!cfg || cfg.disabled) return;

    // If it's a danger item → open confirm modal
    if (cfg.danger) {
      confirm({
        title: cfg.confirmTitle ?? 'Are you sure you want to perform this action?',
        content: cfg.confirmContent ?? null,
        okText: cfg.okText ?? 'Yes',
        cancelText: cfg.cancelText ?? 'No',
        okType: 'danger',
        maskClosable: true, // allow closing when clicking outside
        onOk: async (close) => {
          try {
            if (typeof cfg.callback === 'function') {
              await cfg.callback(actionRecord); // run callback
            }
          } catch (err) {
            console.error('Danger callback error:', err);
          }
          // close modal manually
          close?.();
        },
        onCancel: (close) => {
          close?.(); // explicitly close when cancel clicked
        },
      });
      return;
    }

    // Non-danger item → execute immediately
    try {
      if (typeof cfg.callback === 'function') cfg.callback(actionRecord);
    } catch (err) {
      console.error('Callback error:', err);
    }
  };

  // Build menu
  const menu = (
    <Menu onClick={handleMenuClick}>
      {configs.map((item, idx) => (
        <>
        <Menu.Item key={String(idx)} disabled={!!item.disabled}>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              color: item.danger ? DANGER_COLOR : undefined,
              cursor: item.disabled ? 'not-allowed' : 'pointer',
              userSelect: 'none',
            }}
          >
            {item.icon}
            <span>{item.label}</span>
          </span>
        </Menu.Item>
        {item.sectionEnd && <div className="my-1 h-px w-full bg-gray-200" />
}
        </>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          {title}

        </Space>
      </a>
    </Dropdown>
  );
};

export default ActionsMenu;
